<template>
  <div class="yo-room-list" :class="{ 'yo-open-menu': openMenu }">
    <div>
      <ChatBoxTitle>
        <div slot="left">
          <img class="hide-desktop" src="../img/on-ui.svg" @click="$emit('switch', 'off')" alt="Home" title="Home">
          <!-- <img class="hide-desktop" src="../img/home.svg" @click="$router.push('/') " alt="Home" title="Home"> -->
        </div>
        <div slot="center">
          Search Rooms
          <!-- <a class="title-link" target="_blank" :href="`https://yoteachapp.com/room/${room._id}`" v-if="room && room.title">{{ room.title }}</a> -->
        </div>
        <div slot="right">
          <!-- <img class="hide-desktop" src="../img/create-room.svg" @click="$emit('bar', 'create')" alt="Create room" title="Create room"> -->
          <!-- <img src="../img/home.svg" @click="$router.push('/')" alt="home"> -->
          <!-- <img src="../img/qr.svg" style="cursor: pointer;" @click="() => { show = 'qrcode' }" alt="Qr Code"> -->
        </div>
      </ChatBoxTitle>
    </div>

    <div class="scroll-list">
      <div class="chat-item myrooms">
        <input type="text" class="no-style-search" v-model="roomQuery" :placeholder="`Search ${!roomNumber ? '' : roomNumber} Rooms....`" @input="search({ title: roomQuery ? roomQuery : '_______' })" @keydown.enter="search({ title: roomQuery ? roomQuery : '_______' })">
      </div>
      <ChatItem :dontHide="true" :chosenID="currentRoomID" :section="'others'" :key="'serachchat_' + room._id" :room="room" v-for="room in roomList" @addFav="addFav" @removeFav="removeFav" @select="onSel(room)"></ChatItem>
    </div>

    <TabBar @bar="(v) => { $emit('bar', v) }"></TabBar>

  </div>
</template>

<script>
import _ from 'lodash'
import ChatItem from './ChatListItem.vue'
import TabBar from './TabBar.vue'
import ChatBoxTitle from './ChatBoxTitle.vue'
import { API } from '@/yoteach2-gui/parts/index.js'
export default {
  components: {
    ChatItem,
    TabBar,
    ChatBoxTitle
  },
  props: {
    openMenu: {
      default: false
    },
    currentRoomID: {
      default: false
    }
  },
  data () {
    return {
      favRooms: [],
      roomNumber: false,
      roomQuery: '',
      roomList: [],
      // chosenID: this.currentRoomID,
      lastResult: []
    }
  },
  mounted () {
    this.getRoomCount()
    this.favRooms = API.Status.state.favRooms
    // this.getFeaturedRooms()
  },
  watch: {
    // chosenID () {
    //   this.$emit('currentRoomID', this.chosenID)
    // }
  },
  methods: {
    onSel (room) {
      // this.chosenID = room._id
      this.$emit('currentRoom', room)
      this.$forceUpdate()
    },
    search: _.debounce(function ({ title }) {
      API.searchRoom({ title })
        .then((resp) => {
          this.lastResult = resp.data
          this.roomList = resp.data

          this.refreshFavList()
          this.$forceUpdate()
        })
    }, 500),
    // getFeaturedRooms () {
    //   API.listFeaturedRooms().then((resp) => {
    //     this.roomList = resp.data
    //   })
    // },
    sleep (time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, time)
      })
    },
    async refreshFavList () {
      this.favRooms = API.Status.state.favRooms
      // .slice().filter(r => {
      //   return this.favRooms.map(e => e._id).includes(r._id)
      // })
      this.$forceUpdate()
    },
    isMyFavRoom (room) {
      this.favRooms = API.Status.state.favRooms
      return this.favRooms.map(e => e.title).includes(room.title)
    },
    async addFav ({ room }) {
      if (!this.isMyFavRoom(room)) {
        API.Status.addFavRoom({ favRoom: room })
      }
      this.refreshFavList()
      this.$forceUpdate()
    },
    async removeFav ({ room }) {
      if (this.isMyFavRoom(room)) {
        API.Status.removeFavRoom({ favRoom: room })
      }
      await this.refreshFavList()
      if (this.isMyFavRoom(room)) {
        API.Status.removeFavRoom({ favRoom: room })
      }
      this.$forceUpdate()
    },
    getRoomCount () {
      API.countRooms()
        .then((resp) => {
          this.roomNumber = resp.data
          this.waiting = false
        })
    }
  }
}
</script>

<style scoped>
.yo-room-list{
  height: 100%;
  display: none;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  background-color: rgba(245, 245, 245, 0.52);
}

@media screen and (min-width: 767px){
  .yo-room-list{
    width: 248px;
    display: block;
    border-right: #756365 solid 1px;
    box-sizing: border-box;
    /* border-right: rgba(190, 174, 174, 0.349) solid 1px; */
    /* border-left: rgba(0, 0, 0, 0.34901960784313724) solid 1px; */
  }
}

.scroll-list{
  width: 100%;
  height: calc(100% - (27px + 15px) * 2);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.yo-open-menu.yo-room-list{
  display: block;
}

.chat-room{
  width: calc(100% - 250px);
  background-color: rgba(247, 247, 247, 0.84);
}

.chat-item{
  display: flex;
  justify-content: center;
  align-content: center;
  height: 80px;
  line-height: 40px;
  font-size: 12px;
  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.34901960784313724) inset;
}
.chat-item.myrooms{
  height: 40px;
  /* background: linear-gradient(45deg, rgb(47, 120, 146), rgb(63, 207, 255)); */
  background-color: white;
}
.chat-item.others{
  /* background: linear-gradient(45deg, rgb(47, 120, 146), rgb(63, 207, 255)); */
  background-color: white;
}
.no-style-search{
  font-size: 17px;
  /* height: 38px; */
  /* padding: 6px 10px; */
  background-color: #fff;
  border: 1px solid rgba(255,255,255,0.0);
  /* border-radius: 4px; */
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: calc(100% - 1px);
  margin: 0px;
  width: 100%;
  padding-left: 13px;
  opacity: 1.0;
  color: black;
}

@media screen and (min-width: 767px) {
  .hide-desktop{
    display: none !important;
  }
}

</style>
